import { useRef, useEffect, useState } from 'react';
import { X } from 'lucide-react';
import NotificationList from './NotificationTable';

export default function NotificationModal({ isOpen, onClose }) {
    const dialogRef = useRef<HTMLDialogElement>(null);

    const [notifications, setNotifications] = useState([]);
    const [isLoadingNotification, setIsLoadingNotification] = useState(false);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        if (isOpen) {
            fetchNotification();
            dialog.showModal();
        } else {
            dialog.close();
        }
    }, [isOpen]);

    const handleClose = () => {
        setNotifications([]);
        setIsLoadingNotification(false);
        onClose();
    };

    const fetchNotification = async () => {
        setIsLoadingNotification(true);
        try {
            const response = await fetch("https://user-api.u-slot.vip/api/Alarm/get_notice_list", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Important: allows cookies to be sent and received
                body: JSON.stringify({
                    page: 1,
                    pageSize: 50
                }),
            });

            if (response.ok) {
                const data = await response.json();
                setNotifications(data.data.items);
            } else {
                console.log(response)
            }
            setIsLoadingNotification(false);
        } catch (err) {
            console.log("Notification Fetching Err", err)
        } finally {
            setIsLoadingNotification(false);
        }
    };

    return (
        <dialog
            ref={dialogRef}
            className="backdrop:bg-black/50"
            style={{ width: '50%' }}
        >
            <style>{`
                dialog button.p-2 {
                display: none;
                }
            `}</style>
            <button
                onClick={handleClose}
                className="outline-none absolute top-4 right-4 z-10 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                style={{ margin: '6px' }}
            >
                <X size={36} />
            </button>
            <NotificationList notifications={notifications} isLoading={isLoadingNotification} />
        </dialog>
    );
}